<template>
  <div class="liveMatchesTwo-detail">
    <LiveNav @toggleNav="toggleNav" />
    <!-- <LiveNav /> -->

    <div class="bgcBig">
      <!-- 顶部比赛信息 -->
      <match-info
        v-if="matchInfo.match_id"
        :match-info="matchInfo"
        :show-match-tip="true"
      ></match-info>
      <div class="content">
        <!-- 左侧 标题 视频 礼物 -->
        <div class="main">
          <!-- 直播间详情 -->
          <div class="content-top-title">
            <img
              class="anchor-avatar"
              :src="liveDetail.anchor_avatar || anchor.avatar"
              alt
            />
            <div class="anchor-info">
              <div class="anchor-info-top">
                <h1 class="anchor-title" :title="liveDetail.title">
                  {{ liveDetail.title }}
                </h1>
                <div
                  class="anchor-change anchor-config"
                  v-if="userInfo.nick_name === anchor.nick_name"
                  @click="showLiveSet(true)"
                >
                  {{ $t("user.setting") }}
                </div>
                <div
                  class="anchor-endlive anchor-config"
                  v-if="userInfo.nick_name === anchor.nick_name"
                  @click="toggleEndLiveVisible(true)"
                >
                  {{ $t("pcLive.end") }}
                </div>
                <!-- <div class="match-btn anchor-config" v-if="userInfo.nick_name === anchor.nick_name && userInfo.is_guess_host == 1 && appConfig.quiz_factor & 1" @click="showSendMatch">发起鹰选</div>
                <div class="match-btn anchor-config" v-if="userInfo.nick_name === anchor.nick_name && userInfo.is_guess_host == 1 && appConfig.quiz_factor & 1" @click="showLocalMatch">本场鹰选</div> -->
              </div>
              <div class="anchor-info-bottom">
                <div class="anchor-info-bl">
                  <!-- <img class="anchor-info-level" :src="require(`@/assets/img/level/${liveDetail.tag}.png`)" alt="" /> -->
                  <img
                    class="anchor-info-level"
                    :src="levelToPicture(anchor.user_level)"
                    alt=""
                  />
                  <div class="anchor-nickname text-overflow">
                    {{ liveDetail.anchor_name || anchor.nick_name }}
                  </div>
                  <div class="anchor-house">
                    <img class="icon" src="./img/sport.png" />
                    <span>{{ $t("pcLive.class") }}</span>
                    <img class="icon" src="./img/arrow_right.png" />
                    <span>{{ categoryName }}</span>
                  </div>
                  <!-- <div class="anchor-house">
                    <img class="icon" src="./img/elephant.png" />
                    <span>大象娱乐</span>
                  </div> -->

                  <div class="anchor-house">
                    <img class="icon" src="./img/live_fangjianhao.png" />
                    <span>{{ userLocal }}</span>
                  </div>
                  <div class="anchor-house">
                    <img class="icon" src="./img/live_heat.png" />
                    <span>{{ hot }}</span>
                  </div>
                </div>
                <div class="anchor-info-br">
                  <!-- <div class="anchor-house" @mouseover="qrcodeFlag = true" @mouseleave="qrcodeFlag = false">
                    <img class="icon" src="./img/live_shouji.png" />
                    <span>手机观看</span>
                    <div class="qrcode-box" v-show="qrcodeFlag" @mouseleave="qrcodeFlag = false">
                      <div class="qrcode-content">
                        <qriously :value="downloadUrl" style="width: 100%" />
                      </div>
                      <div class="qrcode-tips">下载猎鹰直播app 精彩看不停</div>
                      <div class="qrcode-download">下载APP</div>
                    </div>
                  </div> -->
                  <div
                    class="anchor-house"
                    @mouseover="shareMouseOver"
                    @mouseout="shareMouseOut"
                  >
                    <img class="icon" src="./img/live_fenxiang.png" />
                    <span>{{ $t("pcLive.share") }}</span>
                    <div
                      class="live-share"
                      @mouseout="shareMouseOut"
                      v-show="fenxiangFlag"
                    >
                      <!-- <div class="top-arrow"></div> -->
                      <!-- <p class="share-title">直播间地址</p> -->
                      <div class="share-link">
                        <div class="share-url">{{ url }}</div>
                        <div
                          class="share-copy"
                          :data-clipboard-text="url"
                          @click="copy()"
                        >
                          {{ $t("pcLive.copyAddress") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="anchor-follow-info">
                    <!-- <div class="follow-nums">{{ fans_count }}</div> -->
                    <div
                      class="follows followed"
                      v-if="isFollowed"
                      @click="onFollow()"
                    >
                      <div class="img-text">
                        <img src="./img/followed.png" alt="" />
                        <div class="text">{{ $t("common.followed") }}</div>
                      </div>
                      <div class="bar"></div>
                      <div class="follow-number">{{ fans_count }}</div>
                    </div>
                    <div class="follows unfollow" @click="onFollow()" v-else>
                      <div class="img-text">
                        <img src="./img/follow.png" alt="" />
                        <div class="text">{{ $t("common.follow") }}</div>
                      </div>
                      <div class="bar"></div>
                      <div class="follow-number">{{ fans_count }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 视频 礼物栏 -->
          <div class="content-video">
            <!-- 视频 -->
            <!-- <div class="video" :style="toggleVideo"> -->
            <div
              class="video"
              ref="video"
              :style="{ height: videoHeight + 'px' }"
            >
              <div class="logo">
                <img style="height: 100%" src="./img/1200@2x.png" alt />
              </div>
              <Match
                ref="Match"
                @toBet="toBet"
                @continueBet="continueBet"
                @changeShowGuessList="changeShowGuessList"
              ></Match>

              <div class="player-wrap">
                <!-- 视频播放器 -->
                <live-matches-two-player
                  ref="player"
                  v-bind="$attrs"
                  @noEnough="noEnough"
                  @moneyEnd="confirmRecharge"
                  @liveFinished="liveFinished"
                  :detail="liveDetail"
                  :hotLives="hotLives"
                  :isAnchor="isAnchor"
                  :danmus="danmus"
                  :isEnterRoom="false"
                />
              </div>
            </div>
            <!-- 礼物 -->
            <live-matches-two-gift
              ref="liveGift"
              @toShowBetList="toShowBetList"
              :glen="guessList.length"
              :detail="liveDetail"
              @sendGiftInfo="sendGiftInfo"
              @usePropsActive="usePropsActive"
              @showToast="showToast"
              :anchor="anchor"
            />
          </div>
        </div>
      </div>
      <!-- <div class="list-panel" v-show="showBetList && userInfo.nick_name != anchor.nick_name">
        <div class="list-title" id="betlist">
          <div>本场鹰选</div>
          <router-link to="/user-center/betHistory" class="btn">
            <div>鹰选历史</div>
            <img src="./img/to-bet-history-arrow.png" alt="" />
          </router-link>
        </div>
        <div class="list-body" v-loading="guessLoading">
          <MatchItem v-for="item in guessList" :key="item.id" :data="item" @toBet="toBet"></MatchItem>
        </div>
      </div> -->
      <!-- 热门直播间 -->
      <div class="recommend-live-list">
        <div class="title">{{ $t("pcLive.topList") }}</div>
        <el-row :gutter="16" class="live-list">
          <el-col
            :span="6"
            class="live"
            v-for="(live, index) of hotLives"
            :key="index"
          >
            <LiveItemHot :live="live" />
          </el-col>
        </el-row>
      </div>

      <!-- <hot-live-broadcasting-room :hotLives="hotLives" /> -->

      <live-matches-two-title-dialog
        v-if="isShowLiveSet"
        :isShowLiveSet="isShowLiveSet"
        :detail="liveDetail"
        :activeCategory="liveDetail.categoryid"
        :title="title"
        @setIsShowLive="setIsShowLive"
        @updateLive="updateLive"
        @showToast="showToast"
      />
    </div>
    <!-- 右侧 聊天框-->
    <ChatroomPrivate
      v-if="isPrivateChat"
      @changePrivateChat="changePrivateChat"
      :liveDetail="liveDetail"
    />
    <ChatroomGroup
      v-if="isGroupChat"
      :style="{ display: isShowGroupChat }"
      @toUserChat="toUserChat"
      @changeGroupChat="changeGroupChat"
      @toGroupInfo="toGroupInfo"
      :liveDetail="liveDetail"
      @openAnchorInfo="openAnchorInfo"
    />
    <ChatroomUser
      v-if="isUserChat"
      @toGroupMembers="toGroupMembers"
      @toGroupChatUserChatBack="toGroupChatUserChatBack"
    />
    <AnchorInfo
      v-if="isAnchorInfo"
      @changeAnchorInfo="changeAnchorInfo"
      @toGroupInfo="toGroupInfo"
      @toGroupChat="toGroupChat"
      @joinGroup="joinGroup"
      @toPrivateChat="toPrivateChat"
      :liveDetail="liveDetail"
    />
    <GroupInfo
      v-if="isGroupInfo"
      :isHeaderShow="true"
      @closeGroupInfo="closeGroupInfo"
      @changeGroupInfo="changeGroupInfo"
      @toGroupMembers="toGroupMembers"
      @toAnchorInfo="toAnchorInfo"
      :liveDetail="liveDetail"
    />
    <GroupMembers
      v-if="isGroupMembers"
      @changeGroupMembers="changeGroupMembers"
      :liveDetail="liveDetail"
      @toUserChat="toUserChat"
    />
    <div
      class="bullet-chat"
      v-show="
        !isPrivateChat &&
        !isGroupChat &&
        !isAnchorInfo &&
        !isGroupInfo &&
        !isGroupMembers &&
        !isUserChat
      "
    >
      <!-- <div class="bullet-chat" v-show="false"> -->
      <div
        class="contact"
        v-if="!(liveAdContact[0].value === '' && liveAdContact[1].value === '')"
        :style="{ height: isHideContact ? '0rem' : '' }"
      >
        <div class="hide" @click="isHideContact = !isHideContact">
          <img v-show="!isHideContact" src="./img/arrow-up.png" alt="" />
          <img v-show="isHideContact" src="./img/arrow-down.png" alt="" />
        </div>
        <div class="title_top">
          <img :src="require('@/assets/live/title_left.png')" alt="" />
          <span>{{ $t("live.announcement") }}</span>
          <img :src="require('@/assets/live/title_right.png')" alt="" />
        </div>
        <div
          class="row"
          v-for="(item, index) in liveAdContact"
          :key="index"
          v-show="item.value"
        >
          <!-- <div class="b">{{ item.title }}：</div> -->
          <div
            class="c"
            :style="{ display: index === 2 ? 'none' : '' }"
            @click="toOutsidePage(item.value)"
          >
            {{ item.value }}
          </div>
          <div class="d">
            <img
              class="copy-contact"
              :data-clipboard-text="item.value"
              @click="copyContact()"
              src="./img/copy.png"
              alt=""
            />
          </div>
        </div>
        <div class="main" v-show="liveAdContactMain">
          {{ liveAdContactMain }}
        </div>
      </div>

      <!-- 贡献榜tab -->
      <!-- <div class="tab_change">
        <div :class="['tab-title', boardTabId === 0 ? 'active' : '']" @click="changeBoard(0)">日贡榜</div>
        <div :class="['tab-title', boardTabId === 1 ? 'active' : '']" @click="changeBoard(1)">周贡榜</div>
        <div :class="['tab-title', boardTabId === 2 ? 'active' : '']" @click="changeBoard(2)">粉丝群</div>
        <span class="note" v-show="unreadMsgGroup">{{ unreadMsgGroup }}</span>
        <div class="tab-arrow" :style="{ left: boardTabId === 0 ? '.86rem' : boardTabId === 1 ? '2rem' : '10rem' }">
          <img v-show="isContributionShow" @click.stop="isContributionShow = !isContributionShow" src="./img/up-arrow.png" alt="" />
          <img v-show="!isContributionShow" @click.stop="isContributionShow = !isContributionShow" src="./img/down-arrow.png" alt="" />
        </div>
      </div> -->
      <!-- 粉丝群 -->
      <!-- <div class="fans-entry" v-show="boardTabId === 2">
        <div class="fans-list" @click="toGroupInfo(item)" v-for="(item, index) in fansGroups" :key="index">
          <div class="fans-content">
            <div class="fans-title text-overflow">{{ item.name }}</div>
            <div class="fans-members">
              <img v-show="item.user_num !== item.limit_num" src="./img/group.png" alt="" />
              <img v-show="item.user_num === item.limit_num" src="./img/group-full.png" alt="" />
              <div :style="{ color: item.user_num === item.limit_num ? '#DB6372' : '' }">{{ item.user_num }}/{{ item.limit_num }}</div>
            </div>
          </div>
          <div class="btn" @click.stop="joinGroup(item)" v-show="!item.is_joined && item.user_num !== item.limit_num">加入</div>
          <div class="btn" @click.stop="toGroupChat(item)" style="background: #02a8a2" v-show="item.is_joined && item.user_num !== item.limit_num">进入群聊</div>
          <div class="btn" @click.stop="toGroupChat(item)" style="background: #db6372" v-show="item.user_num === item.limit_num">该群已满员</div>
        </div>
      </div> -->
      <!-- 贡献榜内容 -->
      <!-- <div class="tab_content" style="overflow: scroll" @mouseover="showOtherRange" @mouseleave="hideOtherRange" v-show="boardTabId !== 2 && isContributionShow">
        <div class="range-list" v-for="(item, i) in threeBeforeRangeList" :key="item.id">
          <div class="number_left">
            <div class="number_range">
              <img v-if="i == 0" src="./img/NO1.png" alt="" />
              <img v-if="i == 1" src="./img/NO2.png" alt="" />
              <img v-if="i == 2" src="./img/NO3.png" alt="" />
            </div>
            <div class="number_range number-range-other" v-if="i > 2">{{ i + 1 }}</div>
            <div class="range-badge">
              <img v-show="item.user.noble_id == 1" src="./img/knight.png" alt="" />
              <img v-show="item.user.noble_id == 2" src="./img/duke.png" alt="" />
              <img v-show="item.user.noble_id == 3" src="./img/emperor.png" alt="" />
            </div>
            <div class="number_name text-overflow">{{ item.user.nick_name }}</div>
            <div class="range-level"><img :src="levelToPicture(item.user.level)" alt="" /></div>
          </div>
          <div class="number_money">{{ item.intimacy != "-" ? item.intimacy.toLocaleString() : item.intimacy }}</div>
        </div>
        <div class="tab_st" v-show="isShowRange">
        <div class="tab_st">
          <div class="range-list" v-for="(item, i) in threeAfterRangeList" :key="item.id">
            <div class="number_left">
              <div class="number_range number-range-other">{{ i + threeBeforeRangeList.length + 1 }}</div>
              <div class="range-badge">
                <img v-show="item.user.noble_id == 1" src="./img/knight.png" alt="" />
                <img v-show="item.user.noble_id == 2" src="./img/duke.png" alt="" />
                <img v-show="item.user.noble_id == 3" src="./img/emperor.png" alt="" />
              </div>
              <div class="number_name text-overflow">{{ item.user.nick_name }}</div>
              <div class="range-level"><img :src="levelToPicture(item.user.level)" alt="" /></div>
            </div>
            <div class="number_money">{{ item.intimacy != "-" ? item.intimacy.toLocaleString() : item.intimacy }}</div>
          </div>
        </div>
      </div> -->
      <div class="private-chatroom-bar" @click="isPrivateChat = true">
        <img src="./img/private-chat.png" alt="" class="a" />
        <div class="b">{{ $t("pcLive.privateChat") }}</div>
        <div class="c" v-show="unreadMsg">{{ unreadMsg }}</div>
        <div class="d"></div>
        <div class="e">{{ $t("pcLive.privateChatEnter") }}</div>
        <img src="./img/forward-arrow.png" alt="" class="f" />
      </div>
      <!-- <ChatRoom :liveDetail="liveDetail" @sendDanmu="sendDanmu" @reloadBackpack="reloadBackpack" @showToast="showToast" @getRewardRange="getRewardRange" ref="socketSend" /> -->
      <ChatRoom
        :liveDetail="liveDetail"
        @reloadBackpack="reloadBackpack"
        @showToast="showToast"
        @getRewardRange="getRewardRange"
        ref="socketSend"
      />
    </div>
    <div class="toast-tips" v-show="toast">{{ toast }}</div>

    <el-dialog
      top="30vh"
      class="endlive-dialog"
      :visible="endLiveVisible"
      center
      width="30%"
    >
      <div class="dia-content">
        <span>{{ $t("pcLive.sureClose") }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel" round @click="toggleEndLiveVisible(false)">{{
          $t("user.cancelText")
        }}</el-button>
        <el-button class="commit" round type="primary" @click="endLive">{{
          $t("user.modalConfirmText")
        }}</el-button>
      </span>
    </el-dialog>

    <SendMatchDialog
      ref="SendMatchDialog"
      :live_id="liveDetail.liveid"
    ></SendMatchDialog>
    <LocalMatchDialog
      ref="LocalMatchDialog"
      :live_id="liveDetail.liveid"
    ></LocalMatchDialog>
    <BetMatchDialog
      ref="BetMatchDialog"
      @getGuessOrderList="getGuessOrderList"
    ></BetMatchDialog>

    <TipYesMatch ref="TipYesMatch"></TipYesMatch>
    <TipNoMatch ref="TipNoMatch"></TipNoMatch>
  </div>
</template>

<script>
import { animate } from "popmotion";
import { post } from "../../util/http";
import { getDate } from "../../util/time";
import MatchInfo from "../../components/match-info/match-info.vue";
import LiveItemHot from "@/components/live-item/live-item-hot";
import LiveMatchesTwoTitleDialog from "../../components/room-intro/liveMatchesTwoTitleDialog.vue";
import LiveMatchesTwoPlayer from "../../components/player/liveMatchesTwoPlayer.vue";
import LiveMatchesTwoGift from "../../components/gift-send/liveMatchesTwoGift.vue";
import HotLiveBroadcastingRoom from "./hotLiveBroadcastingRoom.vue";

import LiveNav from "@/components/live-nav/live-nav";
import ChatRoom from "@/components/chat-room/chat-room";
import ChatroomPrivate from "@/components/chatroom-private/chatroom-private";
import ChatroomGroup from "@/components/chatroom-group/chatroom-group";
import ChatroomUser from "@/components/chatroom-user/chatroom-user";
import AnchorInfo from "@/components/anchor-info/anchor-info";
import GroupInfo from "@/components/group-info/group-info";
import GroupMembers from "@/components/group-members/group-members";
import Match from "@/components/guessing/match";
import SendMatchDialog from "@/components/dialog/SendMatchDialog";
import LocalMatchDialog from "@/components/dialog/LocalMatchDialog";
import BetMatchDialog from "@/components/dialog/BetMatchDialog";
import MatchItem from "@/components/guessing/matchitem";
import TipYesMatch from "@/components/dialog/TipYesMatch";
import TipNoMatch from "@/components/dialog/TipNoMatch";
import Cipboard from "clipboard";
import { mapState, mapMutations, mapActions } from "vuex";
import { levelToPicture } from "@/util/picNumber";
import { timSendGift } from "@/util/tim";
// 以后如果单独封装socket可以使用此文件
// import { getSocket } from "./webSocket";
export default {
  name: "lliveMatchesTwo-detail",
  components: {
    MatchInfo,
    LiveMatchesTwoPlayer,
    LiveMatchesTwoGift,
    HotLiveBroadcastingRoom,
    LiveMatchesTwoTitleDialog,
    LiveItemHot,
    LiveNav,
    ChatRoom,
    ChatroomPrivate,
    ChatroomGroup,
    ChatroomUser,
    AnchorInfo,
    GroupInfo,
    GroupMembers,
    Match,
    SendMatchDialog,
    LocalMatchDialog,
    BetMatchDialog,
    MatchItem,
    TipYesMatch,
    TipNoMatch,
  },
  props: {
    recLive: {
      type: Array,
      default() {
        return [];
      },
    },
    liveDetail: {
      type: Object,
      default() {
        return {};
      },
    },
    anchor: {
      type: Object,
      default() {
        return {};
      },
    },
    // downloadUrl: {
    //   type: String,
    //   default: ""
    // },
    categoryName: {
      type: String,
    },
    liveNotice: {
      type: String,
    },
    userLocal: {
      type: String,
    },
    fans_count: {
      type: Number,
      default: 0,
    },
    recAnchor: {
      type: Object,
      default() {
        return {};
      },
    },
    hotLives: {
      type: Array,
      default() {
        return [];
      },
    },
    isAnchor: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    rangeList: {
      handler(n, o) {
        if (!n) {
          return;
        }
        let rangeList = [...n];
        this.threeBeforeRangeList = rangeList.slice(0, 3);
        this.threeAfterRangeList = rangeList.slice(3);
      },
      immediate: true,
    },
    timGuessList(newVal) {
      this.setGuessList(newVal);
    },
    quizPrompt(newVal) {
      this.closeMatch();
      this.showTipMatch(newVal);
    },
  },

  data() {
    return {
      toast: "", // 全局提示
      isShowLiveSet: false, //修改弹窗
      qrcodeFlag: false,
      fenxiangFlag: false,
      fenxiangTimeOut: {},
      qrcodeUrl: "www.baidu.com",
      boardTabId: 0,
      wsUrl: "",
      welcomeText: "",
      matchInfo: {},
      url: window.location.href,
      giftData: {},
      //前三名
      threeBeforeRangeList: [],
      // 三名后
      threeAfterRangeList: [],
      rangeList: [],
      isShowRange: false,
      endBtnLoading: true,
      downloadUrl: "",
      toggleVideo: "",
      danmus: [],
      endLiveVisible: false,
      title: "",
      guessLoading: false,
      guessList: [],
      guessAlertList: [],
      showBetList: false,
      myGuessOrder: {},
      videoHeight: 705,
      isLiveAdShow: false,
      isHideContact: false,
      isPrivateChat: false,
      isGroupChat: false,
      isUserChat: false,
      isAnchorInfo: false,
      isGroupMembers: false,
      isGroupInfo: false,
      isShowGuessList: [],
      isShowGroupChat: "flex",
      isContributionShow: false,
    };
  },
  created() {
    this.getGuessOrderList();
    let hotInfo = this.hotLives.filter((item) => {
      return item.anchorid == this.$route.params.id;
    });
    this.changeHot(hotInfo[0]?.hot);
  },
  mounted() {
    // console.log("this.wrapHeight", this.wrapHeight);
    this.getRewardRange(0);

    if (this.userInfo.id) {
      this.getUserInfo(); //更新用户金额
    }

    this.videoHeight = (this.$refs.video?.offsetWidth * 9) / 16;
    window.onresize = () => {
      this.videoHeight = (this.$refs.video?.offsetWidth * 9) / 16;
    };
  },
  beforeDestroy() {
    this.$off("liveFinished");
    //页面销毁时关闭长连接

    localStorage.setItem("firstJion", 2);
    if (this.toastTime) {
      clearTimeout(this.toastTime);
    }
  },
  computed: {
    ...mapState([
      "defaultAvatar",
      "categories",
      "userInfo",
      "liveBarrage",
      "showBarrage",
      "appConfig",
      "giftList",
      "wrapHeight",
      "checkAnchorStatus",
      "liveAdContact",
      "liveAdContactMain",
      "timGuessList",
      "quizPrompt",
      "chatList",
      "fansGroups",
      "isFollowed",
      "anchorId",
      "hot",
    ]),
    time() {
      return getDate(new Date() / 1000, "yy-mm-dd hh:mt");
    },
    unreadMsg() {
      // let arr = this.chatList?.filter((e) => e.anchor_id === this.liveDetail.anchorid && e.type === 1);
      // console.log("dddddddddddddddddddddddddd", arr);
      return this.chatList?.filter(
        (e) => e.anchor_id === this.liveDetail.anchorid && e.type === 1
      )[0]?.unread_num;
    },
    unreadMsgGroup() {
      if (this.chatList.length === 0) return;
      let total = 0;
      this.chatList.forEach((e) => {
        if (
          e.anchor_id === this.liveDetail.anchorid &&
          this.liveDetail.anchorid !== this.userInfo.id &&
          e.type === 0
        ) {
          total += e.unread_num || 0;
        }
      });
      return total > 99 ? "99+" : total;
    },
  },
  methods: {
    ...mapMutations([
      "changeUserInfo",
      "toggleLogin",
      "changeLoginType",
      "changeHot",
      "changeFanGroup",
      "changeIsFollowed",
      "changeUserChatId",
      "changeUserChatName",
      "changeEnterUserChatFlag",
    ]),
    ...mapActions(["getAnchorProfile", "addToGroupChat", "getGroupInfo"]),

    levelToPicture,

    toOutsidePage(val) {
      if (val.indexOf("http") > -1) {
        window.open(val, "_blank");
      }
    },

    closeGroupInfo() {
      // console.log(
      //   "isPrivateChat",
      //   this.isPrivateChat,
      //   "isGroupChat",
      //   this.isGroupChat,
      //   "isAnchorInfo",
      //   this.isAnchorInfo,
      //   "isGroupInfo",
      //   this.isGroupInfo,
      //   "isGroupMembers",
      //   this.isGroupMembers,
      //   "isUserChat",
      //   this.isUserChat
      // );
      this.isGroupInfo = false;
      this.isGroupChat = false;
    },
    toGroupChatUserChatBack() {
      this.isUserChat = false;
      this.isShowGroupChat = "flex";
    },
    toUserChat(item) {
      this.isGroupMembers = false;
      // this.isGroupChat = false;
      this.isShowGroupChat = "none";
      this.isUserChat = true;
      this.changeUserChatId(item.id || item.uid);
      this.changeUserChatName(item.nick_name);
      let flag = item.id ? 1 : 2;
      this.changeEnterUserChatFlag(flag);
    },
    openAnchorInfo(anchorId) {
      // this.changeAnchorId(anchorId);
      // this.getAnchorProfile(anchorId);
      this.isAnchorInfo = true;
      // this.isGroupChat = false;
      this.isShowGroupChat = "none";
    },
    changePrivateChat(val) {
      this.isPrivateChat = val;
      this.isShowGroupChat = "flex";
    },
    changeGroupChat(val) {
      this.isGroupChat = val;
    },
    changeAnchorInfo(val) {
      this.isAnchorInfo = val;
      this.isShowGroupChat = "flex";
      // this.isGroupChat = true;
    },
    changeGroupInfo(val) {
      this.isGroupInfo = val;
      this.isShowGroupChat = "flex";
    },
    changeGroupMembers(val) {
      this.isGroupMembers = false;
      this.isGroupInfo = true;
    },
    toGroupChat(group) {
      console.log(group, "group");
      if (this.userInfo.id === this.anchorId) {
        this.showToast(this.$t("pcLive.achorN"));
        return;
      }
      if (!group.is_joined) {
        this.showToast(this.$t("pcLive.join"));
        return;
      }
      this.changeFanGroup(group);
      this.isAnchorInfo = false;
      this.isShowGroupChat = "flex";
      this.isGroupChat = true;
    },
    async joinGroup(group) {
      console.log(group);
      if (this.isFollowed === 0) {
        this.onFollow();
      }
      let res = await this.addToGroupChat(group.group_id);
      console.log("res", res);
      if (res === "SUCCESS") {
        this.changeFanGroup(group);
        this.getAnchorProfile(this.anchorId);
      }
    },
    toGroupInfo(group) {
      if (this.userInfo.id === this.anchorId) {
        this.showToast(this.$t("pcLive.achorN"));
        return;
      }
      if (!group.is_joined) {
        this.showToast(this.$t("pcLive.join"));
        return;
      }
      this.changeFanGroup(group);
      this.getGroupInfo();
      this.isAnchorInfo = false;
      this.isGroupInfo = true;
      this.isShowGroupChat = "none";
      // this.isGroupChat = false;
    },
    toPrivateChat() {
      this.isAnchorInfo = false;
      this.isPrivateChat = true;
    },
    toGroupMembers() {
      this.isGroupMembers = true;
      this.isGroupInfo = false;
      this.isUserChat = false;
    },

    toAnchorInfo() {
      this.isAnchorInfo = true;
      this.isGroupInfo = false;
    },

    copyContact() {
      var copyBtn = new Cipboard(".copy-contact");
      copyBtn.on("success", (e) => {
        this.$message.success(this.$t("copy.success"));
        copyBtn.destroy();
      });
    },

    // sendDanmu(data) {
    //   // this.danmus.push(data);
    //   this.danmus = data;
    // },

    reloadBackpack() {
      console.log("reloadBackpack");
      this.$refs.liveGift.getUserBackpack();
    },

    async getUserInfo() {
      const { data } = await post({
        url: "/api/user/getUserInfo",
      });
      if (data.status == 0) {
        let keyValue = {
          ...JSON.parse(localStorage.getItem("userInfo")),
          diamond: data.data.diamond,
          gold: data.data.gold,
          ...data.data,
          level: Number(data.data.level) || 0,
          process: Number(data.data.process) || 0,
          remainder: Number(data.data.remainder) || 0,
        };
        localStorage.setItem("userInfo", JSON.stringify(keyValue));
        this.changeUserInfo(keyValue);
        return keyValue;
      }
      return false;
    },
    toggleNav(boo) {
      if (!boo) {
        return (this.toggleVideo = "width:14.48rem;height:8.14rem");
      } else {
        return (this.toggleVideo = "width:12.5rem;height:7.08rem");
      }
    },
    getAvatar(ind) {
      if (this.threeBeforeRangeList.length > ind) {
        return (
          this.threeBeforeRangeList[ind].user.avatar ||
          require("./img/icon_avator.png")
        );
      } else {
        return require("./img/icon_avator.png");
      }
    },
    shareMouseOver() {
      if (this.fenxiangTimeOut) {
        this.fenxiangTimeOut["over"] &&
          clearTimeout(this.fenxiangTimeOut["over"]);
        this.fenxiangTimeOut["out"] &&
          clearTimeout(this.fenxiangTimeOut["out"]);
      }
      this.fenxiangTimeOut["over"] = setTimeout(() => {
        this.fenxiangFlag = true;
      }, 30);
    },
    shareMouseOut() {
      if (this.fenxiangTimeOut) {
        this.fenxiangTimeOut["over"] &&
          clearTimeout(this.fenxiangTimeOut["over"]);
        this.fenxiangTimeOut["out"] &&
          clearTimeout(this.fenxiangTimeOut["out"]);
      }
      this.fenxiangTimeOut["out"] = setTimeout(() => {
        this.fenxiangFlag = false;
      }, 30);
    },
    copy() {
      let copyBtn = new Cipboard(".share-copy");
      copyBtn.on("success", () => {
        this.showToast(this.$t("copy.success"));
      });
    },

    toggleEndLiveVisible(val = false) {
      this.endLiveVisible = val;
    },

    async endLive() {
      if (!this.endBtnLoading) return;
      this.endBtnLoading = false;
      try {
        const {
          data: { data },
        } = await post({ url: "/webapi/live/endLive" });
        this.endBtnLoading = true;
        this.endLiveVisible = false;
        this.$store.commit("setIsLiving", false);
        // this.$refs.pushPlayer.endLive();
        // clearInterval(this.timer);
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
      } catch (e) {
        // console.log("退出直播出错", e);
        // location.reload();
        this.endBtnLoading = true;
        this.endLiveVisible = false;
      }
    },
    // 关注
    changeBoard(i) {
      this.boardTabId = i;
      if (i === 2) {
        this.getAnchorProfile(this.anchorId);
        return;
      }
      this.getRewardRange(i);
    },
    showLogin() {
      this.changeLoginType("login");
      this.toggleLogin();
    },
    liveFinished() {
      this.$emit("liveFinished");
    },
    showLiveSet(val) {
      this.isShowLiveSet = val;
      this.title = this.liveDetail.title;
    },

    setIsShowLive(val) {
      this.isShowLiveSet = val;
    },
    updateLive() {
      this.$emit("updateLiveInfo");
    },
    onFollow(val) {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      if (this.userInfo.id == this.anchor.id) {
        this.showToast(this.$t("code.10006"));
        return;
      }
      post({
        url: "/api/anchor/attentAnchor",
        data: {
          anchorid: this.anchor.id,
          // device: str
        },
      }).then(({ data: { data } }) => {
        this.$emit("focus", data.fans_count);
        this.changeIsFollowed(data.type);
        let text =
          data.type == 1
            ? this.$t("live.follow")
            : this.$t("live.followCancel");
        this.showToast(text);
      });
    },

    pushAfterRangeList(num) {
      for (let i = 0; i < num; i++) {
        this.rangeList.push({
          user: { nick_name: this.$t("pcLive.wait") },
          intimacy: "-",
        });
      }
    },
    // 直播贡献排行
    getRewardRange(i) {
      post({
        url: "/api/live/getContributeRank",
        data: { Anchorid: this.anchor.id, type: i },
      }).then(({ data: res }) => {
        if (res.status === 0) {
          if (res.data.length) {
            if (res.data.length < 10) {
              this.rangeList = res.data;
              this.pushAfterRangeList(10 - res.data.length);
            } else {
              this.rangeList = res.data?.slice(0, 10);
            }
          } else {
            this.rangeList = [];
            this.pushAfterRangeList(10);
          }
        }
      });
    },
    showOtherRange() {
      // this.isShowRange = true;
    },
    hideOtherRange() {
      // this.isShowRange = false;
    },
    // 获取组件传过来的礼物信息
    sendGiftInfo(giftId, num) {
      let giftMsg = {
        type: "gift",
        count: num,
        giftid: giftId,
      };
      timSendGift(giftMsg);
      // this.$refs.socketSend.timSendGift(giftMsg);
    },
    usePropsActive(type, id) {
      console.log(type, id);
      this.$refs.socketSend.showProps(type, id);
    },

    showToast(text) {
      if (this.toastTime) {
        clearTimeout(this.toastTime);
      }
      this.toast = text;
      this.toastTime = setTimeout(() => {
        this.toast = "";
      }, 1500);
    },

    confirmRecharge() {
      try {
        this.$messageBox.close();
        this.$messageBox
          .confirm(
            this.$t("live-detail.errorinfo1"),
            this.$t("live-detail.hint"),
            {
              confirmButtonText: this.$t("live-detail.confirm"),
              cancelButtonText: this.$t("live-detail.cancel"),
              type: "warning",
            }
          )
          .then(() => {
            if (!this.userInfo.id) {
              this.toggleLogin();
              return;
            }
            window.location.href = "/user-center/recharge";
          });
      } catch (e) {
        this.$messageBox
          .confirm(
            this.$t("live-detail.errorinfo1"),
            this.$t("live-detail.hint"),
            {
              confirmButtonText: this.$t("live-detail.confirm"),
              cancelButtonText: this.$t("live-detail.cancel"),
              type: "warning",
            }
          )
          .then(() => {
            if (!this.userInfo.id) {
              this.toggleLogin();
              return;
            }
            window.location.href = "/user-center/recharge";
          });
      }
    },
    noEnough() {
      try {
        this.$messageBox.close();
        this.$messageBox
          .confirm(
            this.$t("live-detail.errorinfo2"),
            this.$t("live-detail.hint"),
            {
              confirmButtonText: this.$t("live-detail.confirm"),
              cancelButtonText: this.$t("live-detail.cancel"),
              type: "warning",
            }
          )
          .then(() => {
            if (!this.userInfo.id) {
              this.toggleLogin();
              return;
            }
            window.location.href = "/user-center/recharge";
          });
      } catch (e) {
        this.$messageBox
          .confirm(
            this.$t("live-detail.errorinfo2"),
            this.$t("live-detail.hint"),
            {
              confirmButtonText: this.$t("live-detail.confirm"),
              cancelButtonText: this.$t("live-detail.cancel"),
              type: "warning",
            }
          )
          .then(() => {
            if (!this.userInfo.id) {
              this.toggleLogin();
              return;
            }
            window.location.href = "/user-center/recharge";
          });
      }
    },
    async showSendMatch() {
      let user = await this.getUserInfo();
      // console.log("user: ",user);
      if (user.is_guess_host == 1) {
        this.$refs.SendMatchDialog.open();
      } else {
        this.$message({
          message: this.$t("pcLive.noRight"),
          type: "error",
          customClass: "ly-error",
        });
        setTimeout(() => {
          location.reload();
        }, 1500);
      }
      return;
    },
    showLocalMatch() {
      this.$refs.LocalMatchDialog.open();
    },
    changeShowGuessList(val) {
      this.isShowGuessList.push(val);
    },
    setGuessList(data = []) {
      this.guessLoading = true;
      let guessAlertList = [];
      data.forEach((v) => {
        v.amount_list[0] = v.amount_list[0] / 100;
        v.amount_list[1] = v.amount_list[1] / 100;
        let amount = Number(v.amount_list[0] + v.amount_list[1]);
        v.amount = amount;
        let index0 = 0;
        let index1 = 0;
        if (amount != 0) {
          index0 = (v.amount_list[0] / amount).toFixed(2) * 100;
          index1 = (v.amount_list[1] / amount).toFixed(2) * 100;
        }
        //console.log("index0: ",index0);
        //console.log("index1: ",index1);
        v.progress_list = [index0, index1];
        v.endTime = new Date(v.end_time * 1000);
        v.contentArr = v.content?.split("|") || ["", ""];
        if (v.status == 1 && v.endTime > new Date()) {
          guessAlertList.push({ ...v });
        }
        if (this.myGuessOrder.hasOwnProperty(v.g_id)) {
          v.myGuessOrderNum = this.myGuessOrder[v.g_id];
        } else {
          v.myGuessOrderNum = 0;
        }
        v.odds_list.forEach((val, index) => {
          v.odds_list[index] = val ? val / 100 : 0;
        });
      });
      this.guessList = data;
      let guess = guessAlertList.reverse().pop();
      console.log(this.isShowGuessList, "this.isShowGuessList");
      if (guess && !this.isShowGuessList.includes(guess.g_id)) {
        this.$refs.Match.open(guess);
      } else {
        this.$refs.Match.close();
      }
      this.guessAlertList = guessAlertList;
      console.log("this.guessList: ", this.guessList);
      console.log("this.guessAlertList: ", this.guessAlertList);
      setTimeout(() => {
        this.guessLoading = false;
      }, 800);
    },
    toBet(data = {}) {
      this.$refs.BetMatchDialog.open(data);
    },
    continueBet() {
      this.$refs.Match.close();
      let guessAlertList = [...this.guessAlertList];
      if (guessAlertList.length) {
        let guess = guessAlertList.pop();
        this.$refs.Match.open(guess);
        this.guessAlertList = guessAlertList;
      }
    },
    closeMatch() {
      this.$refs.Match.close();
    },
    toShowBetList() {
      this.showBetList = true;
      this.scrollToCmtList();
    },
    scrollToCmtList() {
      // const now = window.scrollY
      const now = document.querySelector(".gift-activity").offsetTop;
      // console.log("now: ",now);
      //const dist = document.querySelector('#betlist').offsetHeight

      let h = document.querySelector(".hotLiveBroadcastingRoom").offsetHeight;
      const dist = 220 + h;
      animate({
        from: now, // 当前的位置
        to: dist, // 目标位置
        onUpdate: (latest) => {
          console.log("latest: ", latest);
          document.querySelector(".bgcBig").scrollTo(0, latest);
        },
      });
    },
    showTipMatch(info = {}) {
      // console.log("info: ",info);
      let { win = 0 } = info;
      if (win == 1) {
        this.$refs.TipYesMatch.open(info);
      } else {
        this.$refs.TipNoMatch.open(info);
      }
    },

    async getGuessOrderList() {
      // console.log("this.liveDetail: ",this.liveDetail)
      if (!(this.userInfo && this.userInfo.id)) {
        return;
      }
      let params = {
        page: 1,
        size: 99,
        live_id: this.liveDetail.liveid,
        uid: this.userInfo.id,
        status: 0,
      };
      // console.log(data)
      const resVal =
        (await post({
          url: "/api/guess/getGuessOrderList",
          data: params,
        })) || [];
      let {
        data: { data },
      } = resVal;
      // console.log("data: ",data);
      let list = data.guessOrder || [];
      let myGuessOrder = {};
      list.forEach(({ g_id = "" }) => {
        console.log(
          myGuessOrder.hasOwnProperty(g_id),
          myGuessOrder[g_id],
          "myGuessOrder"
        );
        if (g_id) {
          if (myGuessOrder.hasOwnProperty(g_id)) {
            myGuessOrder[g_id] = myGuessOrder[g_id] + 1;
          } else {
            myGuessOrder[g_id] = 1;
          }
        }
      });
      this.myGuessOrder = myGuessOrder;
      console.log("myGuessOrder: ", list, myGuessOrder);
    },
  },
};
</script>

<style scoped lang="scss">
.liveMatchesTwo-detail ::v-deep .dplayer-video-wrap  {
  background: none;
}
.liveMatchesTwo-detail {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: PingFangSC;
  position: relative;
  font-stretch: normal;
  font-style: normal;
  // background: url("./img/8.png") center 0 no-repeat;
  // background-size: 100%;
  display: flex;
  .bgcBig {
    flex: 1;
    height: 100%;
    overflow: scroll;
    margin-right: 0.1rem;
  }

  .content {
    width: 100%;
    margin: 0.12rem 0.1rem 0.5rem 0;
    display: flex;
    .content-font {
      color: #fff;
      font-size: 0.14rem;
    }

    .main {
      flex: 1;

      .content-top-title {
        width: 100%;
        height: 0.8rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.08rem 0.12rem;
        background: #fff;
        border-radius: 0.05rem 0.05rem 0 0;
        box-sizing: border-box;

        .anchor-avatar {
          width: 0.56rem;
          height: 0.56rem;
          border-radius: 50%;
          margin-right: 0.24rem;
        }

        .anchor-info {
          flex: 1;
          height: 0.56rem;
        }

        .anchor-info-top {
          width: 100%;
          height: 0.28rem;
          display: flex;
          align-items: center;
          margin-bottom: 0.04rem;
        }

        .anchor-title {
          max-width: 6rem;
          font-size: 0.22rem;
          color: #333333;
          line-height: 0.28rem;
          font-weight: 500;
          margin-right: 0.16rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }

        .anchor-config {
          padding: 1px 0.15rem;
          line-height: 0.2rem;
          font-size: 0.14rem;
        }

        .anchor-change {
          color: rgba(253, 48, 97, 1);
          background: rgba(253, 48, 97, 0.1);
          border: 1px solid rgba(253, 48, 97, 1);
          border-radius: 0.12rem;
          margin-right: 0.16rem;
          cursor: pointer;
        }

        .anchor-endlive {
          color: #ff4d4d;
          background: rgba(255, 77, 77, 0.1);
          border: 1px solid #ff4d4d;
          border-radius: 0.12rem;
          cursor: pointer;
          margin-right: 0.16rem;
        }

        .match-btn {
          color: #ffa600;
          background: rgba(255, 186, 57, 0.2);
          border: 1px solid #ffa600;
          border-radius: 0.03rem;
          margin-right: 0.16rem;
          cursor: pointer;
          &:hover {
            background: rgba(255, 186, 57, 1);
            color: #ffffff;
          }
        }

        .anchor-info-bottom {
          width: 100%;
          height: 0.24rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.12rem;
          line-height: 0.24rem;
        }

        .anchor-info-bl {
          display: flex;
          align-items: center;
        }
        .anchor-info-level {
          height: 0.18rem;
          margin-right: 0.06rem;
        }

        .anchor-nickname {
          max-width: 2rem;
          color: #666666;
          margin-right: 0.24rem;
        }

        .anchor-house {
          display: flex;
          align-items: center;
          color: #999999;
          margin-right: 0.24rem;
          position: relative;
        }

        .icon {
          width: 0.16rem;
          height: 0.16rem;
          margin-right: 0.04rem;
        }

        .qrcode-box {
          background-color: #fff;
          border-radius: 0.05rem;
          border: 0.03rem solid rgba(253, 48, 97, 1);
          position: absolute;
          top: 0.36rem;
          left: -0.46rem;
          z-index: 10;
          padding: 0.15rem 0.2rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          &:after,
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.1rem solid transparent;
            border-bottom-color: rgba(253, 48, 97, 1);
            top: -0.22rem;
            right: 0.72rem;
          }
          &:after {
            border-bottom-color: #fff;
            top: -0.19rem;
          }
        }

        .qrcode-tips {
          min-width: 1.3rem;
          font-size: 0.12rem;
          color: #999;
          text-align: center;
          line-height: 0.2rem;
          font-weight: 500;
          margin-top: 0.04rem;
          margin-bottom: 0.08rem;
        }

        .qrcode-download {
          margin: 0 auto;
          width: 0.86rem;
          height: 0.28rem;
          line-height: 0.28rem;
          border-radius: 0.18rem;
          border: 0.01rem solid rgba(253, 48, 97, 1);
          font-size: 0.14rem;
          color: rgba(253, 48, 97, 1);
          text-align: center;
          // margin-bottom: 12px;
        }

        .live-share {
          width: 3rem;
          background-color: #fff;
          border-radius: 0.05rem;
          border: 0.03rem solid rgba(253, 48, 97, 1);
          position: absolute;
          top: 0.36rem;
          left: -1.4rem;
          z-index: 10;
          padding: 0.13rem 0.1rem;
          &:after,
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 0.1rem solid transparent;
            border-bottom-color: rgba(253, 48, 97, 1);
            top: -39%;
            right: 38%;
          }
          &:after {
            border-bottom-color: #fff;
            top: -32%;
          }
        }

        .share-title {
          font-size: 0.14rem;
          color: #333333;
          font-weight: 500;
          margin-bottom: 0.16rem;
        }

        .share-link {
          width: 100%;
          height: 0.32rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .share-url {
          flex: 1;
          background: #fff;
          border: 0.01rem solid #eee;
          border-radius: 0.04rem;
          padding: 0.04rem 0.06rem;
          line-height: 0.18rem;
          font-size: 0.14rem;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .share-copy {
          background: #eee;
          padding: 0 0.06rem;
          font-size: 0.12rem;
          color: rgba(253, 48, 97, 1);
          cursor: pointer;
        }

        .anchor-info-br {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }

        .follows {
          width: 1.5rem;
          height: 0.3rem;
          background: linear-gradient(90deg, #fd3061 0%, #d12e55 100%);
          border-radius: 0.3rem;
          font-weight: 400;
          font-size: 0.12rem;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          position: relative;
          img {
            width: 0.2rem;
            height: 0.2rem;
            margin-right: 0.03rem;
          }
          .img-text {
            // width: 0.76rem;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-right: 0.09rem;
          }
          .bar {
            // position: absolute;
            // left: 0.76rem;
            // top: 0.07rem;
            width: 0.01rem;
            height: 0.16rem;
            background-color: rgba(255, 255, 255, 0.5);
          }
          .follow-number {
            text-align: center;
            width: 0.62rem;
          }
        }
        .followed {
          background: #ffffff;
          color: #999999;
          border: 0.01rem solid #dbdbdb;
          img {
            width: 0.12rem;
            height: 0.12rem;
            margin-right: 0.03rem;
          }
          .bar {
            background-color: rgba(219, 219, 219, 0.5);
          }
        }
      }
      .content-video {
        width: 100%;
        // height: auto;

        .video {
          // width: 12.5rem;
          // height: 100%;
          height: 7.05rem;
          width: 100%;
          position: relative;
          .logo {
            position: absolute;
            top: 0.18rem;
            right: 0.31rem;
            height: 0.46rem;
          }
          .player-wrap {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
.bullet-chat {
  width: 3.4rem;
  // height: 8.85rem;
  border-radius: 0.05rem;
  // box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 0.12rem;
  margin-right: 0.4rem;
  border: 0.01rem solid #eee;
  .contact {
    /* background: url("./img/contact-bg.jpg"); */
    background: linear-gradient(90deg, #1e1d1e 0%, #201d1e 100%);

    background-size: 100%;
    background-position: top;
    padding: 0.28rem 0.16rem 0 0.16rem;
    position: relative;
    overflow: hidden;
    .hide {
      position: absolute;
      top: 0.05rem;
      right: 0.1rem;
      cursor: pointer;
      img {
        width: 0.16rem;
        height: 0.16rem;
      }
    }
    .title_top {
      width: 100%;
      margin-bottom: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 0.4rem;
      }
      span {
        font-size: 0.14rem;
        color: #fff;
        margin: 0 0.08rem;
      }
    }
    .row {
      height: 0.26rem;
      display: flex;
      align-items: center;
      background: rgba(132, 134, 146, 0.5);
      border-radius: 0.04rem;
      color: #ffffff;
      margin-bottom: 0.1rem;
      padding: 0 0.1rem;
      .a {
        width: 0.18rem;
        height: 0.18rem;
        margin-right: 0.05rem;
      }
      .b {
        white-space: nowrap;
        overflow: hidden;
        line-height: 0.26rem;
      }
      .c {
        white-space: nowrap;
        overflow: hidden;
        line-height: 0.26rem;
        cursor: pointer;
      }
      .d {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        img {
          width: 0.14rem;
          // margin-right: 0.12rem;
          cursor: pointer;
        }
      }
      &:hover {
        background: linear-gradient(90deg, #fd3061 0%, #cf2d54 100%);
      }
    }
    .main {
      background: rgba(132, 134, 146, 0.5);
      border-radius: 0.04rem;
      color: #ffffff;
      margin-bottom: 0.16rem;
      padding: 0.1rem;
      word-wrap: break-word;
      line-height: 0.2rem;
      &:hover {
        background: linear-gradient(90deg, #fd3061 0%, #cf2d54 100%);
      }
    }
  }
  .announcement {
    height: 0.42rem;
    // background: rgba(38, 217, 157, 0.1);
    border-radius: 0.08rem 0.08rem 0px 0px;
    display: flex;
    padding: 0.08rem 0.16rem;
    align-items: center;
    border-bottom: 0.01rem solid #eee;

    .announce-icon {
      width: 0.24rem;
      height: 0.24rem;
      margin-right: 0.08rem;
    }

    .announce_content {
      width: 2.66rem;
      line-height: 0.2rem;
      font-size: 0.12rem;
      color: #666;
      overflow: hidden;
    }

    .announce_move {
      animation: myMove 15s linear infinite; // 重点，定义动画
      white-space: nowrap;
      display: inline-block;
      animation-fill-mode: forwards;
    }
  }
  .tab_change {
    height: 0.32rem;
    display: flex;
    background-color: #eee;
    color: #000;
    font-weight: 400;
    font-size: 0.12rem;
    z-index: 1;
    position: relative;
    .active {
      position: relative;
      background-color: #fff;
    }
    .note {
      position: absolute;
      top: -0.04rem;
      right: 0.15rem;
      padding: 0 0.05rem;
      min-width: 0.1rem;
      height: 0.2rem;
      line-height: 0.2rem;
      text-align: center;
      border-radius: 0.2rem;
      background: #f64d5c;
      color: #ffffff;
      font-size: 0.12rem;
      margin-left: 0.06rem;
    }
    .tab-arrow {
      position: absolute;
      top: 0.07rem;
      left: 0.86rem;
      img {
        width: 0.16rem;
        cursor: pointer;
      }
    }
  }
  .tab-title {
    flex: 1;
    text-align: center;
    line-height: 0.32rem;
    cursor: pointer;
    background: #f4f4f4;
    box-shadow: inset 0.5px 0px 0px #f0f0f0, inset -0.5px 0px 0px #f0f0f0;
  }
  .fans-entry {
    padding: 0 0.12rem;
    max-height: 1.86rem;
    overflow: scroll;
    .fans-list {
      height: 0.62rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: inset 0px -0.5px 0px #f0f0f0;
      cursor: pointer;
      .fans-title {
        width: 1.57rem;
      }
      .fans-members {
        width: 0.68rem;
        height: 0.2rem;
        background: #eeeeee;
        border-radius: 0.02rem;
        color: #666666;
        font-size: 0.12rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.04rem;
        img {
          width: 0.12rem;
          margin-right: 0.02rem;
        }
      }
      .btn {
        width: 0.88rem;
        height: 0.3rem;
        background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
        border-radius: 0.3rem;
        color: #ffffff;
        line-height: 0.3rem;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .tab_content {
    height: 1.02rem;
    .range-list {
      height: 0.34rem;
      padding: 0 0.12rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .number_left {
        display: flex;
        align-items: center;
      }
      .number_range {
        img {
          width: 0.2rem;
        }
      }

      .number-range-other {
        width: 0.2rem;
        height: 0.2rem;
        border-radius: 50%;
        // background-color: #eee;
        color: #666;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .range-badge {
        img {
          width: 0.24rem;
          margin-left: 0.05rem;
        }
      }
      .number_name {
        max-width: 1.4rem;
        margin-left: 0.05rem;
        line-height: 0.34rem;
      }
      .range-level {
        img {
          height: 0.18rem;
          margin-left: 0.05rem;
        }
      }
      .number_money {
        color: #666;
      }
    }
  }
  .private-chatroom-bar {
    height: 0.42rem;
    display: flex;
    padding: 0 0.12rem;
    align-items: center;
    box-shadow: inset 0px 1px 0px #eeeeee;
    cursor: pointer;
    font-size: 0.12rem;
    .a {
      width: 0.2rem;
      margin-right: 0.05rem;
    }
    .c {
      margin-left: 0.05rem;
      height: 0.2rem;
      min-width: 0.2rem;
      background: #f64d5c;
      border-radius: 0.2rem;
      color: #ffffff;
      padding: 0.05rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .d {
      flex: 1;
    }
    .e {
      color: #999999;
    }
    .f {
      width: 0.16rem;
      margin-left: 0.05rem;
    }
  }
  .tab_st {
    position: relative;
    background: #ffffff;
    z-index: 10;
    height: auto;
  }

  .system_tip {
    font-size: 0.14rem;
    color: #33cc00;
    line-height: 0.2rem;
    position: relative;
    margin-bottom: 0.08rem;
  }
  .chat_content {
    flex: 1;
    border-top: 0.01rem solid #eee;
    border-bottom: 0.01rem solid #eee;
    overflow-y: auto;
    position: relative;
    padding: 0 0.12rem;
    background: #fff;
    .disable_pop {
      position: absolute;
      z-index: 10;
      left: 0;
      top: -0.86rem;
      width: 1.44rem;
      border-radius: 0.08rem;
      box-shadow: 0px 0.03rem 0.12rem 0px rgba(0, 0, 0, 0.1);
      background-color: #fff;
      padding-bottom: 0.12rem;
      > .top {
        padding-top: 0.12rem;
        text-align: center;
        position: relative;
        .del {
          width: 100%;
          position: absolute;
          top: 0.02rem;
          right: 0.02rem;
          color: #969db0;
          font-size: 0.19rem;
          cursor: pointer;
        }
      }
      .user_name {
        font-size: 0.14rem;
        line-height: 0.2rem;
        color: #333333;
        font-weight: 500;
      }
      .confirm_btn {
        width: 0.88rem;
        height: 0.24rem;
        background: #26d99d;
        border-radius: 0.12rem;
        color: #fff;
        font-size: 0.14rem;
        line-height: 0.24rem;
        text-align: center;
        margin: 0 auto;
        margin-top: 0.14rem;
        cursor: pointer;
      }

      .bottom-arrow {
        width: 100%;
        height: 0.04rem;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background: #26d99d;
        border-radius: 0 0 0.04rem 0.04rem;

        &::before {
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          bottom: -0.16rem;
          left: 25%;
          border: 0.08rem solid transparent;
          border-top: 0.08rem solid #26d99d;
        }

        &::after {
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          bottom: -0.1rem;
          left: 25%;
          border: 0.08rem solid transparent;
          border-top: 0.08rem solid #fff;
        }
      }
    }

    .chat_item {
      font-size: 0.14rem;
      line-height: 0.2rem;
      position: relative;
      margin-bottom: 0.08rem;

      .chat {
        position: relative;
        .pendant {
          display: inline;
        }
        img {
          height: 0.2rem;
          margin-right: 0.05rem;
        }
        .left {
          color: #3c9cfe;
          cursor: pointer;
        }
        .me {
          // margin-left: 0.08rem;
          color: #02a8a2;
        }
        .right {
          color: #333333;
          word-break: break-all;
        }

        .mr-8 {
          margin-right: 0.08rem;
        }

        .send-gift {
          font-size: 0.16rem;
          color: #26d99d;
        }
      }
      .disable_chat {
        display: flex;
        align-items: center;
        margin-bottom: 0.08rem;
        position: relative;
        .chao {
          width: 0.16rem;
          height: 0.16rem;
          background: #ff7575;
          border-radius: 0.02rem;
          font-size: 0.1rem;
          color: #ffffff;
          margin-right: 0.08rem;
          text-align: center;
          line-height: 0.16rem;
        }

        .disabled {
          font-size: 0.16rem;
          color: #ff4d4d;
        }
        .nick_name {
          font-size: 0.14rem;
          color: #41939d;
          margin-left: 0.02rem;
          margin-right: 0.02rem;
        }
      }
    }
  }
  .continuous-gift {
    width: 3.4rem;
    position: absolute;
    top: 50%;
    z-index: 3;
    .gift-list {
      width: 3.4rem;
      height: 0.4rem;
      margin-bottom: 0.22rem;
      background: url("./img/gift_bg.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 0.14rem;
      .a {
        max-width: 1.1rem;
        margin-left: 0.12rem;
      }
      .b {
        font-size: 0.12rem;
        margin: 0 0.08rem;
      }
      .c img {
        height: 0.5rem;
        margin-right: 0.08rem;
      }
      .d img {
        height: 0.17rem;
      }
      .e img {
        width: 0.2rem;
        margin: 0 0.08rem;
      }
      .f img {
        height: 0.32rem;
      }
    }
  }
  .gift_content {
    width: 3.4rem;
    height: 4.4rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;

    .gift_conten_img {
      width: 100%;
      height: 100%;
    }
  }

  .to_bottom_btn {
    width: 3.4rem;
    height: 0.3rem;
    background: rgba(2, 168, 162, 0.7);
    text-align: center;
    line-height: 0.3rem;
    position: absolute;
    color: #fff;
    font-size: 0.12rem;
    top: -0.27rem;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;

    &::before {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      top: 60%;
      left: 29%;
      transform: translateY(-50%);
      border: 0.05rem solid transparent;
      border-top: 0.05rem solid #fff;
    }
  }

  .message_bottom {
    position: relative;
    // height: 1.08rem;
    height: 1.2rem;
    padding: 0.12rem 0.16rem;

    .emoji {
      width: 3.39rem;
      // height: 1.2rem;

      position: absolute;
      top: -1.31rem;
      left: 0;
      // display: flex;
      background-color: #fff;
    }
    .emoji-cats {
      display: flex;
      .emoji-cat {
        width: 0.85rem;
        height: 0.3rem;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .emoji-active {
        background-color: #fff;
      }
    }
    .emoji-item {
      height: 1rem;
      padding: 0.1rem;
      overflow: scroll;
      span {
        margin: 0.03rem;
        margin-bottom: 0.05rem;
        display: inline-block;
        cursor: pointer;
      }
    }

    .icon_btn {
      margin-bottom: 0.16rem;
      display: flex;
      align-items: center;
    }

    .icon-img {
      width: 0.24rem;
      height: 0.24rem;
      margin-right: 0.16rem;
      cursor: pointer;
    }
    .icon-bar {
      width: 0.01rem;
      height: 0.18rem;
      background: #eeeeee;
      margin-right: 0.16rem;
    }
    .sent_content {
      width: 100%;
      display: flex;

      .input_content {
        flex: 1;
        background: #ffffff;
        border: 1px solid #f0f0f0;
        border-radius: 0.04rem 0 0 0.04rem;
        height: 0.4rem;
        font-size: 0.12rem;
        justify-content: space-between;
        .not_login {
          background: #f7f7f7;
          padding-left: 0.16rem;
          line-height: 0.4rem;
          .l_text1 {
            color: #26d99d;
            cursor: pointer;
          }
          .l_text2 {
            color: #999999;
          }
        }
        .login_input {
          width: 100%;
          padding: 0.12rem 0.16rem;
          border: none;
          outline: none;
          height: 100%;
        }
      }
      .input_send {
        background: #02a8a2;
        border-radius: 0px 0.04rem 0.04rem 0px;
        color: #fff;
        width: 0.6rem;
        height: 0.4rem;
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.4rem;
        cursor: pointer;
      }
    }
  }
}

.toast-tips {
  padding: 0.1rem 0.26rem;
  font-size: 0.14rem;
  color: #ffffff;
  font-weight: 500;
  line-height: 0.2rem;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 0.44rem;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
}

::v-deep .el-message--warning {
  top: 50% !important;
}
/*文字无缝滚动*/
@keyframes myMove {
  0% {
    transform: translateX(2.52rem);
  }
  100% {
    transform: translateX(-5.73rem);
  }
}

.list-panel {
  .list-title {
    padding: 0.1rem 0.1rem;
    margin: 0.1rem 0rem;
    font-size: 0.16rem;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn {
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      background-image: linear-gradient(to right, #ebf7f5, #ebf7f5),
        linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
      border: 1px solid transparent;
      width: 0.83rem;
      height: 0.28rem;
      border-radius: 0.05rem;
      color: #02a8a2;
      font-weight: 400;
      font-size: 0.14rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: relative;
      img {
        width: 0.12rem;
        height: 0.12rem;
        margin-left: 0.02rem;
      }
    }
  }
}

.recommend-live-list {
  background-color: #fff;
  border-radius: 0.05rem;
  padding: 0.12rem 0.24rem;
  margin-bottom: 0.4rem;
  .title {
    font-size: 0.2rem;
    color: #333333;
    font-weight: 500;
    margin-bottom: 0.16rem;
  }
}
.live-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  // min-height: 5rem;

  .live {
    transition: all 0.2s;
    margin-bottom: 0.32rem;
  }
}

.endlive-dialog {
  ::v-deep .el-dialog__header {
    display: none;
  }
  .dia-content {
    padding: 0.2rem 0.2rem;
    padding-top: 0.3rem;
    color: #333333;
    font-size: 0.18rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cancel,
  .cancel:hover {
    border-color: rgba(208, 45, 84, 1);
    color: rgba(208, 45, 84, 1);
    padding: 0.1rem 0.45rem;
  }
  .commit,
  .commit:hover {
    background: linear-gradient(101.98deg, #ff3838 10.8%, #d02d54 95.33%);
    color: #ffffff;
    padding: 0.1rem 0.45rem;
    border: none;
  }
}
</style>
